import { combineReducers } from 'redux';
import loadingVersion from './loadingVersionReducer';
import refreshVersion from './refreshVersionReducer';
import selectedIds from './selectedIdsReducer';
import notifications from './notificationsReducer';
import body from './bodyReducer';

export default combineReducers({
    loadingVersion,
    refreshVersion,
    selectedIds,
    notifications,
    body
});